import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import { Link } from "react-router-dom";
import Moment from 'moment';
import { API_BASE_URL } from "../../Constants/ApiConstants";

function Vehicles() {
    const [vehicles, setVehicles] = useState([]);
    const [vehicle, setVehicle] = useState([]);
    const [rowSelected, setRowSelected] = useState(null)
    const [displayDetailBox, setDisplayDetailBox] = useState(false)

  useEffect(() => {
    loadVehicles();
    
  }, []);

  const loadVehicles = async () => {
    const response = await fetch(`${API_BASE_URL}/v1/vehicle/list`)
    
    if (!response.ok) {
      console.log(response.statusText)
      return
    }
    const result = await response.json()
    console.log(result)
    setVehicles(result.data.reverse())
  };

  const deleteVehicle = async id => {
    if(window.confirm('Are you sure?')){
      try {
        let response = await axios.post(`${API_BASE_URL}/v1/vehicle/delete/${id}`)
        console.log("Response:",response.data.message)
        toast.success(response.data.message);
        loadVehicles()
      } catch (error) {
        console.log(error.response.data.message)
        toast.error(error.response.data.message);
      }
    }
    
  };

  const activateActions = (e, vehicle) => {
    setDisplayDetailBox(false)
    setRowSelected(vehicle.id)
  }

  const viewVehicle = () => {
    const vehicle = vehicles.find(v => v.id === rowSelected)
    setVehicle(vehicle)
    setDisplayDetailBox(true)
  }

  return (
    <div className="w-full mt-12">
      <ToastContainer />
      <main className="w-full flex-grow p-6">
        <h1 className="text-3xl text-black pb-6">Vehicles</h1>
        <div className="bg-white overflow-auto">

          <div className="flex justify start p-4">
            <div className="pr-3">
              <button
                type="button"
                className="bg-blue-700 disabled:bg-blue-300 text-white font-bold py-1 px-4 rounded"
                disabled={!rowSelected}
                onClick={viewVehicle}
                data-modal-toggle="defaultModal">
                View
              </button>
            </div>
            <div className="pr-5">
              <Link onClick={() => deleteVehicle(rowSelected)}><button className="bg-blue-700 disabled:bg-blue-300 text-white font-bold py-1 px-4 rounded" disabled={!rowSelected}>
                Delete
              </button></Link>
            </div>
            <div className="pr-3">
              <Link to={`/vehicle/create`}><button className="bg-green-700 disabled:bg-blue-300 text-white font-bold py-1 px-4 rounded">
                Create New
              </button></Link>
            </div>

          </div>
          {displayDetailBox &&
            <div className="flex justify start p-4">
              <div className="p-10 w-full bg-green-400">
              <h3 className="text-2xl text-white pb-6">Details:</h3>
                Name:{vehicle.name}<br />
                Code:{vehicle.code}
                <div className="mt-5"><button className="bg-blue-700 text-white font-bold py-1 px-4 rounded" onClick={e => { setDisplayDetailBox(false) }}>Close</button></div>

              </div>
            </div>

          }

          {vehicles.length == 0 && <h1 className="text-2xl text-black pb-6">Loading...</h1>}
          {vehicles.length > 0 && <table className="text-left w-full border-collapse">
            <thead>
              <tr>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">#</th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Name</th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Code</th>
              </tr>
            </thead>
            <tbody>
              {vehicles.map((vehicle, index) => (

                <tr className="hover:bg-grey-lighter" key={index + 1}>
                  <td className="py-4 px-6 border-b border-grey-light">
                    <input checked={vehicle.id === rowSelected} type="radio" onChange={e => { activateActions(e, vehicle) }} />
                  </td>
                  <td className="py-4 px-6 border-b border-grey-light">{index + 1}</td>
                  <td className="py-4 px-6 border-b border-grey-light">{vehicle.name}</td>
                  <td className="py-4 px-6 border-b border-grey-light">{vehicle.code}</td>
                </tr>
              ))}

            </tbody>
          </table> }
          
        </div>
      </main>


    </div>
  )
}

export default Vehicles
